// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickJournalCrtText__display___RlZcq {
    animation: QuickJournalCrtText__crtFlutter___Eqz9L 23s linear infinite;
}

.QuickJournalCrtText__row___ylQOV {
    transition: color var(--quickJournalCrtSettleDuration) ease-in-out;
}

.QuickJournalCrtText__phosphor___WTvUf {
    position: relative;
    color: inherit;
    text-shadow: -0.45px 0 rgba(172, 90, 255, 0.32),
        0.45px 0 rgba(255, 78, 198, 0.22),
        0 0 2px color-mix(in srgb, currentColor 25%, transparent),
        0 0 7px rgba(180, 120, 240, 0.15);
}

.QuickJournalCrtText__phosphor___WTvUf::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    background: repeating-linear-gradient(to bottom, transparent 0 2px, rgba(0, 0, 0, 0.06) 2px 3px);
}

.QuickJournalCrtText__phosphor___WTvUf[data-afterimage]::before {
    content: attr(data-afterimage);
    position: absolute;
    left: 0;
    top: 0;
    white-space: pre;
    pointer-events: none;
    color: inherit;
    text-shadow: 0 0 4px color-mix(in srgb, currentColor 30%, transparent);
    opacity: 0;
    animation: QuickJournalCrtText__crtAfterimage___R3Gbg 650ms ease-out;
}

@keyframes QuickJournalCrtText__crtAfterimage___R3Gbg {
    from { opacity: 0.12; transform: translateY(2px); }
    to { opacity: 0; transform: translateY(0); }
}

@keyframes QuickJournalCrtText__crtFlutter___Eqz9L {
    0%, 92%, 93%, 94%, 100% { opacity: 1; }
    92.5% { opacity: 0.96; }
    93.5% { opacity: 0.98; }
}

.QuickJournalCrtText__timestamp___CXNZk {
    font-variant-numeric: tabular-nums;
}

.QuickJournalCrtText__settling___wi9tE {
    animation: QuickJournalCrtText__crtColorSettle___UQeic var(--quickJournalCrtSettleDuration) ease-in-out;
}

@keyframes QuickJournalCrtText__crtColorSettle___UQeic {
    from {
        color: #8ff7ff;
    }
    to {
        color: var(--quickJournalHistoryColor);
    }
}

@media (prefers-reduced-motion: reduce) {
    .QuickJournalCrtText__display___RlZcq, .QuickJournalCrtText__phosphor___WTvUf[data-afterimage]::before {
        animation: none;
    }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"display": `QuickJournalCrtText__display___RlZcq`,
	"crtFlutter": `QuickJournalCrtText__crtFlutter___Eqz9L`,
	"row": `QuickJournalCrtText__row___ylQOV`,
	"phosphor": `QuickJournalCrtText__phosphor___WTvUf`,
	"crtAfterimage": `QuickJournalCrtText__crtAfterimage___R3Gbg`,
	"timestamp": `QuickJournalCrtText__timestamp___CXNZk`,
	"settling": `QuickJournalCrtText__settling___wi9tE`,
	"crtColorSettle": `QuickJournalCrtText__crtColorSettle___UQeic`
};
module.exports = ___CSS_LOADER_EXPORT___;
